import {
    SET_DIAS_SEMANA,
    SET_DATA_TODOS,
    SET_PIOR_DATA,
    CLEAR_DATA_TODOS,
    SET_SOMATORIO_DIAS,
    SET_SOMATORIO_DIAS_TODAS,
    SET_CLEAR_SOMATORIO_DIAS_TODAS,
} from '../actions/actionTypes';

const initialState = {};

export const dataPedidoReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DATA_TODOS:
            return {
                ...state,
                dataPedido: action.data,
            };
        case SET_PIOR_DATA:
            return {
                ...state,
                piorData: action.data,
            };
        case CLEAR_DATA_TODOS:
            return {
                ...state,
                dataPedido: null,
            };
        case SET_DIAS_SEMANA:
            return {
                ...state,
                diasSemana: action.data,
            };
        case SET_SOMATORIO_DIAS:
            return {
                ...state,
                somatorioDias: action.data,
            };
        case SET_SOMATORIO_DIAS_TODAS:
            for (let faccao in state.somatorioDiasTodas) {
                if (Object.keys(action.data)[0] === faccao) {
                    const somatoriosFiltrados =
                        state.somatorioDiasTodas.length > 0 && state.somatorioDiasTodas.filter(e => !e.includes(faccao));
                    return { ...state, somatorioDiasTodas: { ...somatoriosFiltrados, ...action.data } };
                }
            }
            return {
                ...state,
                somatorioDiasTodas: { ...state.somatorioDiasTodas, ...action.data },
            };
        case SET_CLEAR_SOMATORIO_DIAS_TODAS: 
            return {
                ...state,
                somatorioDiasTodas: {},
            }
        default:
            return state;
    }
};
